define('view/people/disclosures.list.page.view',['require','exports','module','underscore','uikit/uikit','backbone.radio','blockit','./people.left.nav','fukit/fukit','moment','bluebird','view/disclosure/disclosure.modals','view/disclosure/disclosure.list.document.action.buttons','jquery','datakit/datakit'],function(require, exports, module) {
  //prettier-ignore

  var _               = require('underscore'),
      UIKit           = require('uikit/uikit'),
      Radio           = require('backbone.radio'),
      BlocKit         = require('blockit'),
      PeopleLeftNav   = require('./people.left.nav'),
      ROLES           = require('fukit/fukit').Roles,
      moment          = require('moment'),
      Promise         = require('bluebird'),
      DisclosureModals= require('view/disclosure/disclosure.modals'),
      DisclosureListDocumentActionButtons = require('view/disclosure/disclosure.list.document.action.buttons'),
      $               = require('jquery'),
      DataKit       = require('datakit/datakit');

  var redirectToDisclosureForm = function(id) {
    const ROUTE = '/form/answer/';
    const DISCLOSEE_PARAMETER = '/disclosee';

    if(localStorage.getItem('productNewCoiUiValue') === 'true'){
      location.assign(location.origin + '/coi-react' + ROUTE + id + DISCLOSEE_PARAMETER);
    }else{
      location.assign(location.origin + '/coi#form/answer/' + id + DISCLOSEE_PARAMETER);
    }
  };

  var DisclosuresListPageView = BlocKit.ResolveOptionsView.extend({
    resolveOptions: {
      modals: DisclosureModals,
      root: {
        type: BlocKit.TwoColumnLeftRailLayoutView,
        pageHeader: {
          headerText: 'My Profile',
          breadcrumbs: [
            {
              text: 'My Profile',
            },
            {
              text: '',
              route: 'profile:detail',
              behaviors: {
                updateCrumbWithPersonNameBehavior: {
                  behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                  userPrincipalModel: '@resources.userPrincipalModel',
                  optionValues: {
                    text: {
                      model: '@resources.personPrincipalModel',

                      formatter: function(model) {
                        var userPrincipalModel = this.getOption('userPrincipalModel');
                        var displayName = 'Current User';

                        var fullName = userPrincipalModel.get('fullName');
                        var username = userPrincipalModel.get('username');

                        displayName = model.get('fullName');
                        if (displayName.trim().length === 0) {
                          if (fullName && fullName.trim().length > 0) {
                            displayName = fullName;
                          } else if (username && username.length > 0) {
                            displayName = username;
                          }
                        }

                        return displayName;
                      },
                    },
                  },
                },
              },
            },
            {
              text: 'COI Disclosures',
            },
          ],
          actions: [
            {
              text: 'New Disclosure',
              color: 'primary',
              icon: 'plus',
              model: '@resources.disclosureModel',
              templateCollection: '@resources.templateCollection',
              behaviors: {
                ShowModalOnEventBehavior: {
                  eventName: 'press',
                  modalName: 'disclosureTypeModal',
                  behaviorClass: BlocKit.ShowModalOnEventBehavior,
                },
              },
            },
          ],
        },
        contentColumn: {
          behaviors: {
            AuthorizationBehavior: {
              visibleOnlyWhen: [
                {
                  filter: function() {
                    return true;
                  },
                  message: 'You do not have permission to view this page.',
                  roles: [ROLES.COI_WEB_ACCESS, ROLES.COI_DISCLOSEE_WEB_ACCESS],
                },
              ],
              behaviorClass: BlocKit.AuthorizationBehavior,
            },
          },
          components: [
            {
              type: BlocKit.SearchablePageableTableView,
              collection: '@resources.disclosureCollection',
              columns: [
                {
                  text: 'Disclosure Name',
                  behaviors: {
                    navigateToDisclosureOnPress: {
                      behaviorClass: BlocKit.InvokeMethodOnEventBehavior,
                      productCollection: '@resources.productCollection',
                      events: {
                        press: {
                          method: function(model) {
                            redirectToDisclosureForm(model.id);
                          },
                        },
                      },
                    },
                  },
                  attributes: {
                    style: 'cursor: pointer;',
                  },
                  childView: UIKit.Text,
                  childViewOptions: {
                    color: 'primary',
                    underline: true,
                    bindings: {
                      text: 'name',
                    },
                    formatter: function(item) {
                      if (item && item.length > 50) {
                        item = item.slice(0, 50) + '...';
                      }
                      return item;
                    },
                  },
                },
                { text: 'Status', data: 'status' },
                { text: 'Submission Date', data: 'submitDate', formatter: BlocKit.Formatter.date('L LT') },
                {
                  childView: UIKit.Button,
                  childViewOptions: {
                    attributes: {
                      style: 'float: right;',
                    },
                    color: 'primary',
                    text: 'Modify',
                    bindings: {
                      visible: 'modifiable',
                    },
                  },
                  behaviors: {
                    modifyAndNavigateToDisclosureOnPress: {
                      behaviorClass: BlocKit.InvokeMethodOnEventBehavior,
                      productCollection: '@resources.productCollection',
                      events: {
                        press: {
                          method: function(model) {
                            var preventNavigation = false;
                            var buttonView = this.view;
                            var currentProductNameHeader = _.isUndefined($.ajaxSettings.headers)
                              ? false
                              : $.ajaxSettings.headers['Product-Name'];

                            buttonView.loading = true;

                            Promise.try(function() {
                              $.ajaxSetup({ headers: { 'Product-Name': 'COI' } });
                              return model.modifyDisclosure();
                            })
                              .catch(function() {
                                preventNavigation = true;
                              })
                              .finally(function() {
                                if (preventNavigation) {
                                  var options = {
                                    url: '/api/v2/coi/disclosure/extOrgs/updateForModify/' + model.id,
                                    type: 'PUT',
                                    dataType: 'json',
                                  };
                                  DataKit.Ajax.request(options);

                                  redirectToDisclosureForm(model.id);
                                } else {
                                  if (currentProductNameHeader) {
                                    $.ajaxSetup({ headers: { 'Product-Name': currentProductNameHeader } });
                                  } else {
                                    delete $.ajaxSettings.headers['Product-Name'];
                                  }
                                }
                                buttonView.loading = false;
                              });
                          },
                        },
                      },
                    },
                  },
                },

                {
                  width: '4em',
                  childView: DisclosureListDocumentActionButtons,
                },
              ],
              emptyText: 'No disclosures to display.',
            },
          ],
        },
        railColumn: {
          components: [
            {
              type: PeopleLeftNav,
            },
          ],
        },
      },
    },
  });

  module.exports = DisclosuresListPageView;
});

